'use client';

// imports
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { useAtom } from 'jotai';

// lib files
import { changeStationModalAtom } from '@/lib/atoms/change-station-modal';
import { openChangeStationModal } from '@/lib/helpers/open-change-station-modal';
import { ShowDetails } from "@/lib/types/api/show-data";

// styles
import styles from './ShowDetailNoAssetsMessage.module.scss';

interface ShowDetailNoAssetsMessageProps {
  hasFullLengthAssets: boolean;
  isLocalized: boolean;
  show: ShowDetails;
}

const ShowDetailNoAssetsMessage = (props: ShowDetailNoAssetsMessageProps) => {
  const { hasFullLengthAssets, isLocalized, show } = props;
  const [_, setChangeStationModalOpen] = useAtom(changeStationModalAtom);

  // If a show is yet to premiere
  const isPrePremiere: boolean = Boolean(show.premiere_date && new Date(show.premiere_date) > new Date());

  let message = (<>There are no episodes currently available. Check back for updates.</>);

  switch(true) {
    // If there are full length assets or the show is yet to premiere, we don't need to show any message
    case hasFullLengthAssets === true:
    case isPrePremiere === true:
      return null;
    //
    case hasFullLengthAssets === false && isLocalized === false:
      message = (
        <>
          Please&nbsp;
          <button
            className={styles.detail_hero_no_full_length_videos_choose_station_button}
            onClick={() => openChangeStationModal(setChangeStationModalOpen)}
          >
            choose a PBS Station
          </button>
          &nbsp;to see what episodes are available.
        </>);
      break;
    // just keeping this case here so it's clear when we use the default message
    case hasFullLengthAssets === false && isLocalized === true:
    default:
      // use the default message already set above
      break;
  }

  return (
    <div className={styles.detail_hero_no_full_length_videos} data-sentry-component="ShowDetailNoAssetsMessage" data-sentry-source-file="ShowDetailNoAssetsMessage.tsx">
      {message}
    </div>
  )
};

export default ShowDetailNoAssetsMessage;
